module.exports = __webpack_public_path__ + "static/media/answer-correct.1122fc7d.png";